//---------------------
//a-b테스트
//---------------------
const abRouter = [
  {
    path: "/a-b/dateconfirm",
    name: "ab-dateconfirm",
    component: () => import("../views/a-b/DateConfirmView.vue"),
  },
  {
    path: "/a-b/prevention",
    name: "ab-prevention",
    component: () => import("../views/a-b/PreventionView.vue"),
  },
  {
    path: "/reels-kre",
    name: "reels-kre",
    component: () => import("../views/a-b/ReelsNotionLinkView.vue"),
  },
  {
    path: "/reels-kre",
    name: "reels-kre",
    component: () => import("../views/a-b/ReelsNotionLinkView.vue"),
  },
  {
    path: "/subscribe/amount-a",
    name: "subscribe-amount-a",
    component: () => import("../views/subscribe/SubscribeAmount.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/subscribe/amount-b",
    name: "subscribe-amount-b",
    component: () => import("../views/subscribe/SubscribeAmount-B.vue"),
    beforeEnter: (to, from, next) => {
      if (localStorage.naezip_to_ac_se) {
        next();
      } else {
        next("/");
      }
    },
  },
];

export default abRouter;
